import { makeAutoObservable } from 'mobx';

import { Note, NoteFilterFormValues, NoteFilters, NoteRequest } from '../interfaces/note';
import { FilterStore } from '../../shared/util-stores';
import { paginationSmallListLimit } from '../../shared/constants/systemConstants';
import { notesService } from '../services/notesService';
import { resetAllStore } from '../../shared/stores/resetAllStore';

class NotesStore {
  notes: Note[] = [];
  filterMethods: FilterStore<NoteFilterFormValues>;
  customerId: string | null = null;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });

    this.filterMethods = new FilterStore<NoteFilterFormValues>(this.handleGetNotes, {
      elementsPerPage: paginationSmallListLimit,
    });
  }

  setDefaultValues() {
    this.notes = [];
    this.filterMethods.setDefaultValues();
    this.customerId = null;
  }

  getNotes(customerId?: string) {
    if (customerId) {
      this.setCustomerId(customerId);
    }
    return this.filterMethods.getData();
  }

  async createNote(note: NoteRequest) {
    await notesService.createNote(note);

    return this.filterMethods.getData();
  }

  async updateNote(id: number, note: NoteRequest) {
    await notesService.updateNote(id, note);

    return this.filterMethods.getData();
  }

  async deleteNote(id: number) {
    await notesService.deleteNote(id);

    return this.filterMethods.getData();
  }

  private async handleGetNotes(filterData: NoteFilters) {
    const data = this.customerId
      ? await notesService.getNotesByCustomer(this.customerId, filterData.requestedPage)
      : await notesService.getAllNotes(filterData.requestedPage);

    this.setNotes(data.content);

    return data;
  }

  private setNotes(notes: Note[]) {
    this.notes = notes;
  }

  setCustomerId(customerId: string) {
    this.customerId = customerId;
  }
}

const notesStore = new NotesStore();

resetAllStore.addResetMethod(notesStore.setDefaultValues);

export { notesStore, NotesStore };
